
import { overflowContainerMixin } from '../../mixins'
import EoSpinner from '../EoSpinner/EoSpinner'
import EoImg from '../EoImg/EoImg.vue'

export default {
  name: 'EoNpoPlayer',
  components: {
    EoImg,
    EoSpinner,
  },
  mixins: [
    overflowContainerMixin,
  ],
  props: {
    autoplay: {
      type: Boolean,
      default: false,
    },
    /**
     * Media ID from POMS (https://pomslookup.eo.nl/)
     */
    id: {
      type: String,
      default: '',
    },
    /**
     * Soon deprecated: media ID from POMS (https://pomslookup.eo.nl/)
     */
    mid: {
      type: String,
      default: '',
    },
    /**
     * Tracking: AT Internet site id
     */
    atSiteId: {
      type: [Number, String],
      default: null,
    },
    /**
     * Tracking: AT Internet user id
     */
    atUserId: {
      type: String,
      default: null,
    },
    /**
     * Tracking: AT Internet user id cookie duration
     */
    atUserIdDuration: {
      type: [Number, String],
      default: null,
    },
    /**
     * Overwrite default placeholder image (before player is loaded)
     */
    poster: {
      type: String,
      default: null,
    },
    /**
     * Hide and remove the iframe from the DOM
     */
    hidden: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      src: null,
    }
  },
  watch: {
    poster: {
      handler: function (url) {
        this.$emit('poster', url)
      },
      immediate: true,
    },
    mid: {
      handler: function () {
        this.fetchSrc()
      },
    },
  },
  mounted () {
    this.fetchSrc() // fetch unique embed url from API
  },
  methods: {
    async fetchSrc () {
      const currentLocation = window?.location?.href || 'https://www.eo.nl/'
      const response = await this.$library.api.get(`/poms/npoplayer`, {
          params: {
            atinternetSiteId: this.atSiteId,
            atinternetUserId: this.atUserId,
            atinternetUserIdCookieDuration: this.atUserIdDuration,
            hasAdConsent: 1,
            mid: this.id || this.mid,
            noAds: 1,
            overlayUrl: this.poster,
            autoplay: this.autoplay ? 1 : 0,
            referralUrl: currentLocation,
          },
        },
      )
      this.src = response?.data?.embedUrl
    },
  },
}
